const getDefaultState = () => ({
  schedules: {
    loading: false,
    error: false,
    items: [],
    search: '',
  },
  editSchedules: {
    loading: false,
    error: false,
    items: [],
    search: '',
  },
  scheduleSubs: {
    loading: false,
    error: false,
    items: [],
  },
  deletedSchedule: {
    loading: false,
    error: false,
    items: [],
  },
  postSchedule: {
    loading: false,
    error: false,
    items: [],
  },
  patchSchedule: {
    loading: false,
    error: false,
    items: [],
  },
  scheduleValues: {
    loading: false,
    error: false,
    items: [],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/schedules/defaultState.js